/**
 * The one control height.
 *
 * Inputs, selects and buttons are 32px and the small size is 26px; anything else on a row
 * looks wrong before anybody can say why. It is a constant rather than three copies because
 * the copies drift, and the drift is only ever visible on the one screen nobody opened.
 *
 * `aria-invalid` turns the border red: it is set on the one control a save was refused
 * over (`fieldProblem.ts`), so the attribute a screen reader announces and the colour
 * somebody sees are the same fact.
 *
 * Its own file, so that the modules holding it beside a component do not trip
 * `react/only-export-components`.
 */
export const CONTROL =
  'h-8 w-full px-2.5 rounded-control bg-surface-2 border border-rule text-body text-ink aria-invalid:border-danger';
